// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3vSjD","noInteraction":"EventWrapper_noInteraction__1RNL6"};